import Vue from 'vue'
import { router } from '@src/routes'

export default {
  namespaced: true,
  state: {
    region: [], // { defaultValue: number, list: string[] }[]
    locale: [],
    languagesAvailable: [],
  },
  getters: {
    region(state) {
      return state.region
    },
    locale(state) {
      return state.locale
    },
    languagesAvailable(state) {
      return state.languagesAvailable
    },
  },
  mutations: {
    LoadRegion(state, data) {
      state.region = data
    },
    LoadLocale(state, data) {
      state.locale = data
    },
    LoadLanguages(state, data) {
      state.languagesAvailable = data
    },
  },
  actions: {
    LoadLocale(context) {
      return new Promise((resolve, reject) => {
        let localeJson = locale
        let regionJson = region
        if (context.state.locale && context.state.locale.length > 0) {
          resolve()
        } else {
          context.commit('LoadLocale', localeJson)
          context.commit('LoadRegion', regionJson)

          // записываем в куку текущий регион
          // let currentRegion = regionJson.find(item => item.current).id;
          Vue.cookie.set('regionId', regionJson.defaultValue, { expires: '1Y' })

          const regionSlug = regionJson.list.find(region => region.id === regionJson.defaultValue)?.slug
          Vue.cookie.set('regionSlug', regionSlug, { expires: '1Y' })
          // let cookieRegion = Vue.cookie.get('region');
          // if (cookieRegion === null) {
          //     Vue.cookie.set('region', currentRegion, { expires: '1Y' });
          // } else {
          //     if (regionJson.find(item => item.id === cookieRegion)) {
          //
          //     }
          // }

          let base_local = ''
          let currentLocale = null
          let locale = null
          let locale_arr = []
          if (localeJson) {
            for (let i = 0; i < localeJson.length; i++) {
              locale_arr.push(localeJson[i].languagesAvailable.value)
              localeJson[i].languagesAvailable.forEach(item => {
                locale_arr.push(item.value)
              })
            }
            localeJson.forEach(item => {
              item.languagesAvailable.forEach(i => {
                if (i.current) {
                  currentLocale = i
                }
              })
            })
          }

          // let path = [];
          // for (let i = 0; i < router.options.routes.length; i++) {
          //     path.push(router.options.routes[i].path);
          // }

          locale = currentLocale.value

          let pathname = window.location.pathname.split('/')

          if (locale === null) {
            if (pathname[1] === '') {
              locale = navigator.systemLanguage || window.navigator.language || navigator.userLanguage || navigator.browserLanguage

              if (locale_arr.indexOf(locale) >= 0) {
                // Vue.cookie.set('locale', locale, { expires: '1Y' });

                base_local = locale
                // } else {
                //     Vue.cookie.set('locale', '', { expires: '1Y' });
              }
            } else {
              if (locale_arr.indexOf(pathname[1]) >= 0) {
                base_local = pathname[1]
                // } else {
                //     if (path.indexOf('/' + pathname[1]) >= 0) {
                //         Vue.cookie.set('locale', '', { expires: '1Y' });
                //     } else {
                //         console.log('error');
                //     }
              }
            }
          } else {
            if (locale === pathname[1]) {
              base_local = locale
            } else {
              if (locale_arr.indexOf(pathname[1]) >= 0) {
                // Vue.cookie.set('locale', pathname[1], { expires: '1Y' });
                base_local = pathname[1]
                // } else {
                //     if (path.indexOf('/' + pathname[1]) >= 0) {
                //         Vue.cookie.set('locale', '', { expires: '1Y' });
                //     } else {
                //         console.log('error');
                //     }
              }
            }
          }

          if (base_local === '') {
            router.history.base = base_local
            Vue.http.options.root = '/api'
            resolve()
          } else {
            router.history.base = '/' + base_local
            Vue.http.options.root = '/api/' + base_local

            let newPath = ''
            for (let i = 2; i < pathname.length; i++) {
              newPath += '/' + pathname[i]
            }

            if (window.location.search) {
              newPath += window.location.search
            }
            if (window.location.hash) {
              newPath += window.location.hash
            }

            reject(newPath)
          }
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/locale.js